export default __webpack_public_path__ + "static/A_0087_3-157276ad9401ae84dd3183d3b0658c8c.webm";